import React from 'react';
import { FiShield, FiChevronDown } from 'react-icons/fi';
import { useInternalStaff } from './InternalStaffRoute';
import StaffAuthenticatorAccount from './StaffAuthenticatorAccount';

export default function StaffSetupBanner() {
  const staff = useInternalStaff();
  if (!staff?.mfa_setup_prompt) return null;
  return <section className="staff-security-banner" aria-label="Authenticator setup">
    <details>
      <summary><FiShield aria-hidden="true" /><strong>Set up your authenticator app</strong><span>Protect your staff account</span><FiChevronDown className="staff-security-chevron" aria-hidden="true" /></summary>
      <div className="staff-security-content"><StaffAuthenticatorAccount required onComplete={staff.completeMfaSetup} /></div>
    </details>
  </section>;
}
